import React from 'react';
import PropTypes from 'prop-types';

const InputLogin = ({ type, name, label, placeholder, value, disabled, onChange }) => (
  <div className="input-group">
    <label htmlFor="email" className="main__label">
      {label}
    </label>
    <input
      type={type}
      id={name}
      name={name}
      required
      value={value}
      disabled={disabled}
      className="input-text input-text--box"
      placeholder={placeholder}
      onChange={onChange}
    />
  </div>
);

InputLogin.defaultProps = {
  disabled: undefined,
};

InputLogin.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default InputLogin;
